import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import classnames from "classnames";
import jwt_decode from "jwt-decode";
import { Rating } from "react-simple-star-rating";
import moment from "moment";
import {
  Alert,
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Collapse,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  Nav,
  NavItem,
  NavLink,
  Pagination,
  PaginationItem,
  PaginationLink,
  Spinner,
  Row,
  TabContent,
  TabPane,
  Table
} from "reactstrap";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Select from "react-select";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import axios from "../api/axios";
import { SERVER_URL } from "../ServerLink";
import { MaintenanceFlowDetailsForm } from "./MaintenanceFlowDetailsForm";
import ExportTicketsModal from "./ExportTicketsModal";
import { requestTypeLabel } from "../../helpers/requestTypeLabel";

// ─────────────────────────────────────────────────────────────
// WorkflowStatusCell — renders inline workflow details in table
// ─────────────────────────────────────────────────────────────
const WorkflowStatusCell = ({ status, workflow }) => {
  const cellStyle = {
    minWidth: 200,
    fontSize: "0.78rem",
    verticalAlign: "middle",
    padding: "6px 8px",
    lineHeight: 1.6,
  };

  const row = (label, value) =>
    value ? (
      <div key={label}>
        <span style={{ fontWeight: 500 }}>{label}:</span> {value}
      </div>
    ) : null;

  const fmtDate = (d, includeYear = true) => {
    if (!d) return null;

    const date = new Date(d);

    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", {
      month: "short",
      timeZone: "UTC",
    });
    const year = date.getUTCFullYear();

    return includeYear ? `${day} ${month} ${year}` : `${day} ${month}`;
  };

  if (!workflow) {
    return (
      <td style={cellStyle}>
        <span style={{ color: "var(--bs-secondary)", fontSize: "0.75rem" }}>—</span>
      </td>
    );
  }

  const { scheduling, progress, closure, history, residentFeedbackConfirmed, updatedAt } = workflow;

  if (status === "Scheduled") {
    return (
      <td style={cellStyle}>
        <div style={{ fontWeight: 600, marginBottom: 3 }}>📅 Scheduled</div>
        {row("Date", fmtDate(scheduling?.date))}
        {row(
          "Time",
          scheduling?.timeSlot?.start
            ? `${scheduling.timeSlot.start} – ${scheduling.timeSlot.end}`
            : null
        )}
        {row("Tech", scheduling?.technicianName)}
        {row("Phone", scheduling?.technicianPhone)}
        {!scheduling?.date && !scheduling?.technicianName && (
          <span style={{ color: "var(--bs-secondary)" }}>Not yet scheduled</span>
        )}
      </td>
    );
  }

  if (status === "Inprogress") {
    return (
      <td style={cellStyle}>
        <div style={{ fontWeight: 600, marginBottom: 3 }}>🔧 In Progress</div>
        {row("Notes", progress?.notes)}
        {row("Parts", progress?.partsOrdered)}
        {row("ETA", fmtDate(progress?.expectedArrivalDate, false))}
        {row("Follow-up", fmtDate(progress?.followUpDate, false))}
        {!progress?.notes && !progress?.partsOrdered && !progress?.expectedArrivalDate && (
          <span style={{ color: "var(--bs-secondary)" }}>No details yet</span>
        )}
      </td>
    );
  }

  if (status === "Completed") {
    const closedByName = closure?.closedBy?.userId
      ? `${closure.closedBy.userId.first_name || ""} ${closure.closedBy.userId.last_name || ""}`.trim()
      : null;

    const closedDate = fmtDate(closure?.closedAt) || fmtDate(updatedAt);

    return (
      <td style={cellStyle}>
        <div style={{ fontWeight: 600, marginBottom: 3 }}>✅ Completed</div>
        {row("Closed", closedDate)}
        {row("Notes", closure?.notes)}
        {row("By", closedByName)}
        <div>
          <span style={{ fontWeight: 500 }}>Feedback:</span>{" "}
          {residentFeedbackConfirmed ? (
            <span style={{ color: "var(--bs-success)" }}>✓ Confirmed</span>
          ) : (
            <span style={{ color: "var(--bs-warning)" }}>✗ Pending</span>
          )}
        </div>
      </td>
    );
  }

  if (status === "Unresolved") {
    const historyArr = history || [];
    const lastEntry = historyArr[historyArr.length - 1];
    return (
      <td style={cellStyle}>
        <div style={{ fontWeight: 600, marginBottom: 3 }}>⚠️ Unresolved</div>
        {row("Reason", closure?.notes)}
        {lastEntry?.at && row("Last update", fmtDate(lastEntry.at))}
        {!closure?.notes && !lastEntry && (
          <span style={{ color: "var(--bs-secondary)" }}>No details recorded</span>
        )}
      </td>
    );
  }

  // Open / default
  return (
    <td style={cellStyle}>
      <div style={{ fontWeight: 600, marginBottom: 3 }}>📋 Open</div>
      <span style={{ color: "var(--bs-secondary)", fontSize: "0.75rem" }}>
        Awaiting assignment
      </span>
    </td>
  );
};

const TechnicalStaffTickets = () => {
  const decode = jwt_decode(window.localStorage.getItem("accessToken"));
  const VENDOR_PORTAL_TICKETS = `/ticket/technicalstaff/${decode.id}`;
  const TOTAL_TICKETS_URL = `/ticket/total`;
  const [modal_large, setmodal_large] = useState(false);
  const [modal_details, setmodal_details] = useState(false);
  const [modal_workflow, setmodal_workflow] = useState(false);
  const [modal_export, setmodal_export] = useState(false);
  const [portalTikets, setportalTikets] = useState([]);
  const [customActiveTab, setcustomActiveTab] = useState("1");
  const [startDate, setStartDate] = useState(Date.now());
  const [startTime, setStartTime] = useState("");
  const [status, setStatus] = useState("");
  const [endDate, setEndDate] = useState(Date.now());
  const [endTime, setEndTime] = useState("");
  const [notes, setNotes] = useState("");
  const [estimatedAmount, setestimatedAmount] = useState("");
  const [selectedTicket, setSelectedTicket] = useState("");
  const [quoteError, setQuoteError] = useState("");
  const [propertyID, setPropertyID] = useState("");
  const [priority, setPriority] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [totalTickets, setTotalTickets] = useState(0);
  const [propertyList, setPropertyList] = useState([]);
  const [property, setProperty] = useState("");
  const [showlogs, setShowLogs] = useState({
    data: [],
    value: false,
  });
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState({
    total: 0,
    open: 0,
    inprogress: 0,
    completed: 0,
    unresolved: 0,
  });
  const [model_open, setModel_open] = useState(false);
  const [moveTo, setMoveTo] = useState("");
  const [checked, setchecked] = useState(false);
  const [selectedName, setSelectedName] = useState([]);
  const [vendor, setVendor] = useState([]);
  const [specialties, setSpecialities] = useState([]);
  const [vendorError, setVendorError] = useState("");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedRating, setSelectedRating] = useState([]);
  const [selectedContact, setSelectedContact] = useState([]);
  const [tableCheck, setTableCheck] = useState(false);
  const [tableContent, setTableContent] = useState("");
  const [selectedEmail, setSelectedEmail] = useState([]);
  const [technicalStaff, setTechnicalStaff] = useState([]);
  const [originalStaff, setOriginalStaff] = useState([]);
  const [myticket, setMyTicket] = useState("");
  const [filterFromDate, setFilterFromDate] = useState();
  const [filterToDate, setFilterToDate] = useState();
  const [filterStatus, setFilterStatus] = useState("");
  const [requestTypes, setRequestTypes] = useState([]);
  const [requestTypeFilter, setRequestTypeFilter] = useState({
    label: "",
    value: "",
  });
  const [ticketIDs, setTicketIDs] = useState([]);
  const [filterID, setFiletrID] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showNotes, setShowNotes] = useState([]);
  const [ticketID, setticketID] = useState("");
  const [notesInput, setNotesInput] = useState("");
  const [notesCount, setNotesCount] = useState([]);
  const [ticketStatus, setTicketStatus] = useState(status);
  const [timeTaken, setTimeTaken] = useState(null);
  const [comment, setComment] = useState("");
  const [inventoryItemConsumedDetails, setInventoryItemConsumedDetails] = useState(null);
  const [inventoryItemsAvailableToBeConsumed, setInventoryItemsAvailableToBeConsumed] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedQuantity, setSelectedQuantity] = useState({ value: 1, label: '1' });
  const [commentForDetailsByConsumer, setCommentForDetailsByConsumer] = useState("");
  const [statusHoverData, setStatusHoverData] = useState({});

  const tog_export = () => setmodal_export(!modal_export);
  const fetchStatusHoverData = async (item) => {
    const id = item._id;
    if (statusHoverData[id]) return;

    setStatusHoverData(prev => ({ ...prev, [id]: 'loading' }));

    try {
      const response = await axios.get(`v2/maintenance/workflow/${id}/history`);
      if (response.data?.success) {
        setStatusHoverData(prev => ({ ...prev, [id]: response.data.data }));
      } else {
        setStatusHoverData(prev => ({ ...prev, [id]: 'error' }));
      }
    } catch (e) {
      setStatusHoverData(prev => ({ ...prev, [id]: 'error' }));
    }
  };

  const StatusHoverContent = ({ item, hoverData }) => {
    const status = item?.status;

    if (hoverData === 'loading') {
      return (
        <div style={{ textAlign: 'center', padding: '4px', minWidth: '160px' }}>
          <Spinner size="sm" /> <span style={{ fontSize: '0.78rem' }}> Loading...</span>
        </div>
      );
    }

    if (!hoverData || hoverData === 'error') {
      return (
        <div style={{ fontSize: '0.78rem', minWidth: '160px' }}>
          <p className="mb-0 text-muted">No data available.</p>
        </div>
      );
    }

    const workflow = hoverData?.workflow;
    const scheduling = workflow?.scheduling;
    const progress = workflow?.progress;
    const closure = workflow?.closure;

    if (status === 'Scheduled') {
      return (
        <div style={{ textAlign: 'left', fontSize: '0.78rem', minWidth: '200px' }}>
          <p className="mb-1"><strong>📅 Scheduled Visit</strong></p>
          <p className="mb-1">
            Date:{' '}
            {scheduling?.date
              ? new Date(scheduling.date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
              : 'Not set'}
          </p>
          <p className="mb-1">
            Time:{' '}
            {scheduling?.timeSlot
              ? `${scheduling.timeSlot.start} – ${scheduling.timeSlot.end}`
              : 'Not set'}
          </p>
          <p className="mb-1">Technician: {scheduling?.technicianName || 'Not assigned'}</p>
          <p className="mb-0">Phone: {scheduling?.technicianPhone || 'N/A'}</p>
        </div>
      );
    }

    if (status === 'Inprogress') {
      return (
        <div style={{ textAlign: 'left', fontSize: '0.78rem', minWidth: '200px' }}>
          <p className="mb-1"><strong>🔧 In Progress</strong></p>
          <p className="mb-1">Notes: {progress?.notes || 'None'}</p>
          <p className="mb-1">Parts Ordered: {progress?.partsOrdered || 'None'}</p>
          <p className="mb-1">
            Expected Arrival:{' '}
            {progress?.expectedArrivalDate
              ? new Date(progress.expectedArrivalDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
              : 'Not set'}
          </p>
          <p className="mb-0">
            Follow-up:{' '}
            {progress?.followUpDate
              ? new Date(progress.followUpDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
              : 'Not set'}
          </p>
        </div>
      );
    }

    if (status === 'Completed') {
      return (
        <div style={{ textAlign: 'left', fontSize: '0.78rem', minWidth: '200px' }}>
          <p className="mb-1"><strong>✅ Completed</strong></p>
          <p className="mb-1">
            Closed At:{' '}
            {closure?.closedAt
              ? new Date(closure.closedAt).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
              : workflow?.updatedAt
                ? new Date(workflow.updatedAt).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
                : 'Not set'}
          </p>
          <p className="mb-1">Notes: {closure?.notes || 'N/A'}</p>
          <p className="mb-1">
            Closed By:{' '}
            {closure?.closedBy
              ? `${closure.closedBy.first_name || ''} ${closure.closedBy.last_name || ''}`.trim()
              : 'N/A'}
          </p>
          <p className="mb-0">
            Feedback Confirmed: {workflow?.residentFeedbackConfirmed ? '✓ Yes' : '✗ No'}
          </p>
        </div>
      );
    }

    if (status === 'Unresolved') {
      const historyArr = workflow?.history || [];
      const lastEntry = historyArr[historyArr.length - 1];
      return (
        <div style={{ textAlign: 'left', fontSize: '0.78rem', minWidth: '200px' }}>
          <p className="mb-1"><strong>⚠️ Unresolved</strong></p>
          <p className="mb-1">Reason: {closure?.notes || 'Not specified'}</p>
          <p className="mb-0">
            Last Updated:{' '}
            {lastEntry?.at
              ? new Date(lastEntry.at).toLocaleString('en-GB', { dateStyle: 'medium', timeStyle: 'short' })
              : 'Not set'}
          </p>
        </div>
      );
    }

    // Open / fallback
    const firstTicketHistory = hoverData?.ticketHistory?.[0];
    return (
      <div style={{ textAlign: 'left', fontSize: '0.78rem', minWidth: '200px' }}>
        <p className="mb-1"><strong>📋 Open</strong></p>
        <p className="mb-1">ID: {hoverData?.primaryID || 'N/A'}</p>
        <p className="mb-0">
          Submitted:{' '}
          {firstTicketHistory?.createdAt
            ? new Date(firstTicketHistory.createdAt).toLocaleString('en-GB', { dateStyle: 'medium', timeStyle: 'short' })
            : 'N/A'}
        </p>
      </div>
    );
  };

  const GET_INVENTORY_ITEMS_BY_REQUEST_TYPE = "v2/inventory/items/request-types";
  const GET_CONSUMED_INVENTORY_ITEMS_BY_MAINTENANCE_TICKET = `v2/inventory/consumed/ticket/:ticket_id`;
  const getAvailableInventoryItems = async (params) => {
    const response = await axios.get(GET_INVENTORY_ITEMS_BY_REQUEST_TYPE, {
      params: params,
    })
    setInventoryItemsAvailableToBeConsumed(response?.data?.data?.items || [])
  }
  async function consumeInventoryItems(ticket_id, itemId, quantity, comment) {
    if (!ticket_id || !itemId || !quantity) {
      console.warn('ticket_id, itemId, and quantity are required to consume inventory.');
      return;
    }
    try {
      const response = await axios.post(
        `v2/inventory/${ticket_id}/consume`,
        { itemId, quantity, comment }
      );
      return response;
    } catch (error) {
      if (error.isAxiosError) {
        throw new Error(`Failed to consume inventory: ${error.response?.data?.message || error.message}`);
      }
      throw new Error(`Failed to consume inventory: ${error.message}`);
    }
  }
  const fetchConsumedItemsDetails = async ({ _id }) => {
    if (!_id) {
      console.warn('No ticket ID provided, setting inventoryItemConsumedDetails to null');
      setInventoryItemConsumedDetails(null);
      return;
    }
    try {
      const apiUrl = GET_CONSUMED_INVENTORY_ITEMS_BY_MAINTENANCE_TICKET.replace(':ticket_id', _id);
      const response = await axios.get(apiUrl);
      if (response.status >= 200 && response.status < 300 && response.data.success) {
        setInventoryItemConsumedDetails(response.data.data);
      } else {
        console.warn('API request succeeded but returned unsuccessful response:', response.data.message);
        setInventoryItemConsumedDetails(null);
      }
    } catch (error) {
      console.error('Error fetching consumed items:', {
        ticketId: _id,
        errorMessage: error.message,
        response: error.response ? {
          status: error.response.status,
          statusText: error.response.statusText,
          data: error.response.data,
        } : 'No response received (network error or timeout)',
      });
      setInventoryItemConsumedDetails(null);
    }
  };
  const generateQuantityOptions = (quantity) => {
    const options = [];
    for (let i = 1; i <= quantity; i++) {
      options.push({ value: i, label: `${i}` });
    }
    return options;
  };
  const itemOptions = inventoryItemsAvailableToBeConsumed.map(item => ({
    value: item._id,
    label: item.name,
    quantity: item.quantity
  }));
  const handleItemChange = (option) => {
    setSelectedItem(option);
    setSelectedQuantity(null);
  };
  const handleQuantityChange = (selectedOption) => {
    setSelectedQuantity(selectedOption ? selectedOption : '');
  };
  const handleCommentForDetailsByConsumer = (e) => {
    setCommentForDetailsByConsumer(e.target.value);
  };
  const ADD_VENDOR = "/vendor/get_vendors";
  const NOTES = "ticket/add_notes";
  const GET_NOTES = "ticket/get_notes";
  const PDF_DOWNLOAD_URL = "/ticket/view_ticket_documents";
  function tog_open_view() {
    setModel_open(!model_open);
  }
  const getVendor = async (companyID, ticket) => {
    try {
      setMyTicket(ticket);
      let response;
      if (decode.role === "manager") {
        response = await axios.get(ADD_VENDOR + "/" + decode.companyId);
      } else if (decode.role === "company") {
        response = await axios.get(ADD_VENDOR + "/" + decode.id);
      } else response = await axios.get(ADD_VENDOR + "/" + companyID);
      if (response.data?.success) {
        getTechnicalStaff(companyID);
        setVendor(response?.data?.vendors);
        response?.data?.vendors?.map((vendorItem, index) => {
          setSpecialities((prevSpecialities) => {
            const newSpecialitiesSet = new Set(prevSpecialities);
            newSpecialitiesSet.add(vendorItem.specialties[0]?.specialty);
            return Array.from(newSpecialitiesSet);
          });
        });
      } else {
        setVendorError(response.data?.errorMessage);
      }
    } catch (error) {
      setVendorError("Something went wrong");
      console.log(error);
    }
  };
  const getTechnicalStaff = async (companyID) => {
    try {
      let body = {
        from: "vendor",
        companyId: companyID,
      };
      const response = await axios.post(
        `/technicalStaff/get_technical_staff?page=${1}&limit=1000`,
        {
          body: body,
        }
      );
      if (response.data.technicalStaff) {
        const temp = response.data.technicalStaff;
        setTechnicalStaff(temp);
        setOriginalStaff(temp);
      }
    } catch (e) {
      console.log(e);
    }
  };
  const specificVendorSearch = async () => {
    let filterList = vendor;
    if (selectedName.length > 0) {
      filterList = vendor.filter((item) => {
        if (selectedName.includes(item.first_name)) {
          return item;
        }
      });
    }
    if (selectedRating.length > 0) {
      filterList = filterList.filter((item) => {
        if (selectedRating.includes(item.rating)) {
          return item;
        }
      });
    }
    if (selectedCategories.length > 0) {
      filterList = filterList.filter((item) => {
        if (selectedCategories.includes(item.specialties[0].specialty)) {
          return item;
        }
      });
    }
    if (selectedContact.length > 0) {
      filterList = filterList.filter((item) => {
        if (selectedContact.includes(item.contact_no)) {
          return item;
        }
      });
    }
    setVendor(filterList);
  };
  const clear = () => {
    setSelectedName([]);
    setSelectedRating([]);
    setSelectedEmail([]);
    setSelectedContact([]);
    setSelectedCategories([]);
    setTechnicalStaff(originalStaff);
    getVendor();
  };
  const technicalStaffSearch = () => {
    let filterList = originalStaff;
    if (selectedName.length > 0) {
      filterList = originalStaff.filter((item) => {
        if (selectedName.includes(item.first_name)) {
          return item;
        }
      });
    }
    if (selectedRating.length > 0) {
      filterList = filterList.filter((item) => {
        if (selectedRating.includes(item.rating)) {
          return item;
        }
      });
    }
    if (selectedEmail.length > 0) {
      filterList = filterList.filter((item) => {
        if (selectedEmail.includes(item.email)) {
          return item;
        }
      });
    }
    if (selectedContact.length > 0) {
      filterList = filterList.filter((item) => {
        if (selectedContact.includes(item.contact_no)) {
          return item;
        }
      });
    }
    setTechnicalStaff(filterList);
  };
  const moveToSpecificVendor = async (id, staff_id) => {
    setLoading(true);
    try {
      let response;
      if (moveTo == "specific vendors") {
        response = await axios.post("ticket/move_to_specific_vendor", {
          ticketID: myticket,
          vendorID: staff_id,
        });
      } else {
        response = await axios.post("ticket/move_to_technicalStaff", {
          ticketID: myticket,
          assignedStaff: staff_id,
        });
      }
      setLoading(false);
      if (response.data.success) {
        window.location.reload();
      }
      window.location.reload();
    } catch (error) {
      console.log("Unable to fetch");
      setLoading(false);
    }
  };
  const moveToAllVendor = async (id) => {
    setLoading(true);
    try {
      const response = await axios.post("/ticket/move_to_vendor_portal", {
        ticketID: myticket,
      });
      if (response.data.success) {
        window.location.reload();
      }
      setLoading(false);
    } catch (error) {
      console.log("Unable to fetch");
      setLoading(false);
    }
  };
  function tog_large() {
    setmodal_large(!modal_large);
  }
  const [col5, setcol5] = useState(false);
  const t_col5 = () => {
    setcol5(!col5);
  };
  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };
  async function TotalTicket(url, data) {
    try {
      const response = await axios.post(url, data);
      if (response.status === 200) {
      } else {
        console.log("Unable to fetch the resoureces");
      }
    } catch (error) {
      console.log("unable to get applicants", error);
    }
  }
  const getTotalTickets = async () => {
    await TotalTicket(TOTAL_TICKETS_URL, {
      role: decode.role,
      domain: decode.domain,
      customerId: decode.id,
    });
  };
  useEffect(() => {
    const run = async () => {
      await getTotalTickets();
    };
    run();
  }, []);
  const getTechnicalStaffTickets = async (pgNum = 1, type) => {
    try {
      let response;
      let query = {
        pageNumber: pgNum,
        startDate: filterFromDate,
        endDate: filterToDate,
        status: filterStatus,
        propertyID: propertyID,
        filterID: filterID?.value,
        requestType: requestTypeFilter.value,
      };
      response = await axios.post(VENDOR_PORTAL_TICKETS, query);
      if (response.data.status === 200) {
        setportalTikets(response.data.tickets);
        setTotalTickets(response.data.totalCount);
        setPropertyList(response.data.propertyList);
        setRequestTypes(response.data.requestTypes);
        setNotesCount(response.data.notesCount);
        setStats({
          total: response.data.total?.Total || 0,
          open: response.data.total?.Open?.count || response.data.total?.Open || 0,
          inprogress: response.data.total?.Inprogress?.count || response.data.total?.Inprogress || 0,
          completed: response.data.total?.Completed?.count || response.data.total?.Completed || 0,
          unresolved: response.data.total?.Unresolved?.count || response.data.total?.Unresolved || 0,
          scheduled: response.data.total?.Scheduled?.count || response.data.total?.Scheduled || 0,
        });
        if (type === "next") setPageNumber(pageNumber + 1);
        if (type === "previous") setPageNumber(pageNumber - 1);
        if (type === "search") setPageNumber(pgNum);
      } else {
        setportalTikets([]);
      }
    } catch (error) {
      setportalTikets([]);
      console.log(error);
    }
  };
  const getTechnicalStaffTicketIds = async () => {
    try {
      const response = await axios.post(VENDOR_PORTAL_TICKETS);
      if (response.data.status === 200) {
        setTicketIDs(response.data.tickets.map((t) => t._id));
      }
    } catch (error) {
      console.log(error);
    }
  };
  const clearFunc = () => {
    setPropertyID("");
    setProperty("");
    setPriority("");
    setFiletrID("");
    setFilterFromDate("");
    setFilterToDate("");
    setFilterStatus("");
    setRequestTypeFilter("");
    getTechnicalStaffTickets();
  };
  const getNotes = async (ticketID) => {
    setShowNotes([]);
    setticketID(ticketID);
    const payload = {
      id: decode.id,
      user: decode.role,
      ticketId: ticketID,
    };
    const response = await axios.post(GET_NOTES, payload);
    if (response.data.status === 200) {
      setShowNotes(response.data.notes);
    }
  };
  const sendNotes = async (ticketId) => {
    if (notesInput.length > 0) {
      try {
        const payload = {
          user: decode.role,
          id: decode.id,
          notes: notesInput,
          ticketId,
          name: decode.firstname,
        };
        const response = await axios.post(NOTES, payload);
        if (response.status === 200) {
          setNotesInput("");
          getNotes(ticketID);
        }
      } catch { }
    } else {
      return;
    }
  };
  useEffect(() => {
    const init = async () => {
      await getTechnicalStaffTickets();
      await getTechnicalStaffTicketIds();
    };
    init();
  }, []);
  const handlePrint = (data) => {
    const printContent = `
      <div class="print-template">
        <table style="border-collapse: collapse; width: 100%;">
          <tr>
            <td colspan="2" style="text-align: center; padding: 10px; border: 1px solid #ccc;">
              <h2>Ticket Details</h2>
              <p>ID : ${data._id.substring(data._id.length - 6)}</p>
            </td>
          </tr>
          <tr>
            <td style="padding: 10px; border: 1px solid #ccc;">Property Name:</td>
            <td style="padding: 10px; border: 1px solid #ccc;">${data.property}</td>
          </tr>
          <tr>
            <td style="padding: 10px; border: 1px solid #ccc;">Company Name:</td>
            <td style="padding: 10px; border: 1px solid #ccc;">${data.companyDomain}</td>
          </tr>
          <tr>
            <td style="padding: 10px; border: 1px solid #ccc;">Name:</td>
            <td style="padding: 10px; border: 1px solid #ccc;">${data.name}</td>
          </tr>
          <tr>
            <td style="padding: 10px; border: 1px solid #ccc;">Email:</td>
            <td style="padding: 10px; border: 1px solid #ccc;">${data.email}</td>
          </tr>
          <tr>
            <td style="padding: 10px; border: 1px solid #ccc;">Phone:</td>
            <td style="padding: 10px; border: 1px solid #ccc;">${data.phone}</td>
          </tr>
          <tr>
            <td style="padding: 10px; border: 1px solid #ccc;">Suite:</td>
            <td style="padding: 10px; border: 1px solid #ccc;">${data.suite}</td>
          </tr>
          <tr>
            <td style="padding: 10px; border: 1px solid #ccc;">Request Type:</td>
            <td style="padding: 10px; border: 1px solid #ccc;">${requestTypeLabel(data)}</td>
          </tr>
          <tr>
            <td style="padding: 10px; border: 1px solid #ccc;">Details:</td>
            <td style="padding: 10px; border: 1px solid #ccc;">${data.details}</td>
          </tr>
          <tr>
            <td style="padding: 10px; border: 1px solid #ccc;">Status :</td>
            <td style="padding: 10px; border: 1px solid #ccc;">${status}</td>
          </tr>
        </table>
      </div>
    `;
    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
      <html>
        <head>
          <title>Ticket Details</title>
        </head>
        <body>${printContent}</body>
      </html>
    `);
    printWindow.document.close();
    printWindow.print();
  };
  const customHumanize = (createdAt) => {
    const momentDate = moment(createdAt);
    const duration = moment.duration(moment().diff(momentDate));
    if (duration.asMinutes() < 60) {
      const minutes = Math.floor(duration.asMinutes());
      return minutes === 1 ? "1 min" : `${minutes} mins`;
    } else if (duration.asHours() < 24) {
      const hours = Math.floor(duration.asHours());
      return hours === 1 ? "1 hr" : `${hours} hrs`;
    } else if (duration.asDays() < 30) {
      const days = Math.floor(duration.asDays());
      return days === 1 ? "1 day" : `${days} days`;
    } else {
      const months = Math.floor(duration.asMonths());
      return months === 1 ? "1 mo" : `${months} mos`;
    }
  };
  const statusOptions = [
    { value: "Scheduled", label: "Schedule Maintenance Visit", color: "#0d6efd" },
    { value: "Inprogress", label: "Inprogress", color: "#ffc107" },
    { value: "Completed", label: "Completed", color: "#198754" },
    { value: "Unresolved", label: "Unresolved", color: "#dc3545" },
  ];
  const handleStatusChange = (opt, item) => {
    const newStatus = opt.value;
    setTicketStatus(newStatus);
    setSelectedTicket(item);

    getAvailableInventoryItems({
      property_id: item.propertyID,
      building_name: item.building,
      request_type: item.requestType,
    });
    fetchConsumedItemsDetails(item);

    if (newStatus === "Scheduled") {
      const alreadyHasDate = item.scheduledDate || item.scheduledVisitDate;
      if (!alreadyHasDate) {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const localToday = `${yyyy}-${mm}-${dd}`;
        setSelectedTicket((prev) => ({
          ...prev,
          scheduledDate: localToday,
        }));
      }
    }
    tog_workflow();
  };
  const tog_details = () => {
    setmodal_details(!modal_details);
  };
  const tog_workflow = () => {
    setmodal_workflow(!modal_workflow);
  };

  const renderPageNumbers = () => {
    const totalPages = Math.ceil(totalTickets / 10);
    const maxVisiblePages = 10;
    const pages = [];

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      let startPage = Math.max(1, pageNumber - 3);
      let endPage = Math.min(totalPages, pageNumber + 3);

      if (startPage === 1) {
        endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
      }
      if (endPage === totalPages) {
        startPage = Math.max(1, endPage - maxVisiblePages + 1);
      }

      if (startPage > 1) {
        pages.push(1);
        if (startPage > 2) pages.push('...');
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      if (endPage < totalPages) {
        if (endPage < totalPages - 1) pages.push('...');
        pages.push(totalPages);
      }
    }

    return pages.map((page, idx) => {
      if (page === '...') {
        return (
          <PaginationItem key={`ellipsis-${idx}`} disabled>
            <PaginationLink href="#">...</PaginationLink>
          </PaginationItem>
        );
      }

      return (
        <PaginationItem
          key={page}
          active={page === pageNumber}
          onClick={(e) => {
            e.preventDefault();
            getTechnicalStaffTickets(page, "search");
          }}
        >
          <PaginationLink href="#">{page}</PaginationLink>
        </PaginationItem>
      );
    });
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Rentdigicare | Maintenance Request</title>
        </MetaTags>
        <div className="container-fluid">
          <Breadcrumbs title="Home" breadcrumbItem="Maintenance Request" />
          <Row>
            <Col xl={12}>
              <Card>
                <CardHeader>
                  <div className="row align-items-center">
                    <div className="col-md-6 d-flex">
                      <div className="mb mx-2">
                        <h5 className="card-title">
                          Total
                          <span className="text-muted fw-normal ms-1">
                            ({stats?.total})
                          </span>
                        </h5>
                      </div>
                      <div className="mx-2">
                        <h5 className="card-title">
                          Open
                          <span className="text-muted fw-normal ms-1">
                            ({stats?.open})
                          </span>
                        </h5>
                      </div>
                      <div className="mx-2">
                        <h5 className="card-title">
                          Inprogress
                          <span className="text-muted fw-normal ms-1">
                            ({stats?.inprogress})
                          </span>
                        </h5>
                      </div>
                      <div className="mx-2">
                        <h5 className="card-title">
                          Completed
                          <span className="text-muted fw-normal ms-1">
                            ({stats?.completed})
                          </span>
                        </h5>
                      </div>
                      <div className="mx-2">
                        <h5 className="card-title">
                          Scheduled
                          <span className="text-muted fw-normal ms-1">
                            ({stats?.scheduled})
                          </span>
                        </h5>
                      </div>
                      <div className="mx-2">
                        <h5 className="card-title">
                          Unresolved
                          <span className="text-muted fw-normal ms-1">
                            ({stats?.unresolved})
                          </span>
                        </h5>
                      </div>
                    </div>
                    <div className="col-md-6 d-flex flex-wrap align-items-center justify-content-end">
                      <div className="mb d-flex flex-wrap">
                        <button
                          onClick={t_col5}
                          className="btn btn-primary mo-mb-2 mr-10"
                          type="button"
                          style={{ cursor: "pointer" }}
                        >
                          Filters
                        </button>
                        <button
                          onClick={tog_export}
                          className="btn btn-success mo-mb-2 ms-2"
                          type="button"
                          style={{ cursor: "pointer" }}
                        >
                          <i className="bx bx-file-export me-1"></i>
                          Export Excel
                        </button>
                        <ExportTicketsModal
                          isOpen={modal_export}
                          toggle={tog_export}
                          propertyList={propertyList}
                          requestTypes={requestTypes}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <Collapse className="mt-4" isOpen={col5}>
                        <Card>
                          <CardBody>
                            <div className="filter-sec">
                              <Form>
                                <div class="row align-items-center">
                                  <div className="col-md-3">
                                    <div className="mb-3">
                                      <Label
                                        htmlFor="example-date-input"
                                        className="form-Label"
                                      >
                                        From
                                      </Label>
                                      <Input
                                        className="form-control"
                                        onChange={(e) => {
                                          setFilterFromDate(e.target.value);
                                        }}
                                        value={filterFromDate}
                                        type="date"
                                        defaultValue={Date.now()}
                                        id="example-date-input"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="mb-3">
                                      <Label
                                        htmlFor="example-date-input"
                                        className="form-Label"
                                      >
                                        To
                                      </Label>
                                      <Input
                                        className="form-control"
                                        type="date"
                                        value={filterToDate}
                                        onChange={(e) => {
                                          setFilterToDate(e.target.value);
                                        }}
                                        defaultValue={Date.now()}
                                        id="example-date-input"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="mb-3">
                                      <Label className="form-Label">
                                        Request Id
                                      </Label>
                                      <Select
                                        value={filterID}
                                        onChange={(e) => {
                                          setFiletrID(e);
                                        }}
                                        options={ticketIDs.map((id) => {
                                          return {
                                            value: id,
                                            label: id.substring(id.length - 6),
                                          };
                                        })}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="mb-3">
                                      <Label className="form-Label">
                                        Status
                                      </Label>
                                      <select
                                        className="form-select"
                                        onChange={(e) => {
                                          setFilterStatus(e.target.value);
                                        }}
                                        value={filterStatus}
                                      >
                                        <option selected>Select</option>
                                        <option value={"Open"}>Open</option>
                                        <option value={"Scheduled"}>Scheduled</option>
                                        <option value={"Inprogress"}>Inprogress</option>
                                        <option value={"Completed"}>Completed</option>
                                        <option value={"Unresolved"}>
                                          Unresolved
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="mb-3">
                                      <Label className="form-Label">
                                        Property
                                      </Label>
                                      <Select
                                        value={property}
                                        onChange={(e) => {
                                          if (e.value === "all") {
                                            setPropertyID(null);
                                            setProperty(e);
                                          } else {
                                            setPropertyID(e.value);
                                            setProperty(e);
                                          }
                                        }}
                                        options={[
                                          { value: "all", label: "All" },
                                          ...propertyList?.map((p) => {
                                            return {
                                              value: p._id,
                                              label: p.title,
                                            };
                                          }),
                                        ]}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="mb-3">
                                      <Label
                                        className="form-label"
                                        htmlFor="formrow-submitted-input"
                                      >
                                        Request Type
                                      </Label>
                                      <Select
                                        value={
                                          requestTypeFilter?.value
                                            ? requestTypeFilter
                                            : ""
                                        }
                                        placeholder="Select type"
                                        options={requestTypes?.map((item) => {
                                          return {
                                            value: item,
                                            label: item,
                                          };
                                        })}
                                        onChange={(e) => {
                                          setRequestTypeFilter(e);
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-2 text-end">
                                    <button
                                      type="submit"
                                      className="btn btn-primary"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        getTechnicalStaffTickets();
                                      }}
                                    >
                                      Search
                                    </button>
                                  </div>
                                  <div className="col-md-1">
                                    <button
                                      type="submit"
                                      className="btn btn-light"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        clearFunc();
                                      }}
                                    >
                                      Clear
                                    </button>
                                  </div>
                                  <div className="col-md-12 d-flex flex-wrap align-items-center justify-content-end">
                                    <div className="mb d-flex flex-wrap justify-content-end"></div>
                                  </div>
                                  <div className="col-md-12">
                                    <div className="col-md-4"></div>
                                  </div>
                                </div>
                              </Form>
                            </div>
                          </CardBody>
                        </Card>
                      </Collapse>
                    </div>
                  </div>
                </CardHeader>
                <CardBody>
                  <div className="table-responsive" style={{ maxHeight: "70vh", overflowY: "auto" }}>
                    <Table className="table-striped table-bordered mb-0">
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">ID</th>
                          <th style={{ minWidth: "90px" }}>Suite No.</th>
                          <th style={{ minWidth: "150px" }}>Type</th>
                          <th scope="col" style={{ minWidth: "12rem" }}>
                            Property / Building Name
                          </th>
                          <th scope="col" style={{ minWidth: "9rem" }}>
                            Submitted By
                          </th>
                          <th scope="col" style={{ minWidth: "6rem" }}>
                            Created
                          </th>
                          <th scope="col" style={{ minWidth: "4rem" }}>
                            Age
                          </th>
                          <th scope="col" style={{ minWidth: "10rem" }}>
                            Permission
                          </th>
                          {/* ── NEW: Workflow details column ── */}
                          <th scope="col" style={{ minWidth: "13rem" }}>
                            Workflow Details
                          </th>
                          <th scope="col" style={{ minWidth: "8rem" }}>
                            Status
                          </th>
                          <th
                            scope="col"
                            style={{ minWidth: "5rem", maxWidth: "5rem" }}
                            title="Attachment"
                            className="text-center align-middle"
                          >
                            Att.
                            <i className="bx bx-paperclip fs-6"></i>
                          </th>
                          <th scope="col">Action</th>
                          <th scope="col">Assign</th>
                          <th scope="col">History</th>
                          <th scope="col">Memo</th>
                        </tr>
                      </thead>
                      <tbody>
                        {portalTikets.map((item, index) => {
                          return (
                            <tr key={item._id}>
                              <td>{(pageNumber - 1) * 10 + index + 1}</td>
                              <td className="text-uppercase">
                                {item._id.substring(item._id.length - 6)}
                              </td>
                              <td>{item.suite}</td>
                              <td>{requestTypeLabel(item)}</td>
                              <td>
                                {item?.property || "NA"}
                                <br />
                                <small>{item?.building || "NA"}</small>
                              </td>
                              <td style={{ fontSize: "0.8rem" }}>
                                {item?.name || "NA"}
                              </td>
                              <td>
                                {moment(item.createdAt).format("DD-MM-YY")}
                              </td>
                              <td>{customHumanize(item.createdAt)}</td>
                              <td style={{ fontSize: "0.8rem" }}>
                                {item?.permission || "NA"}
                              </td>

                              {/* ── NEW: WorkflowStatusCell renders inline workflow info ── */}
                              <WorkflowStatusCell
                                status={item.status}
                                workflow={item.maintenanceWorkflow}
                              />

                              <td className="text-capitalize text-center">
                                <OverlayTrigger
                                  placement="left"
                                  delay={{ show: 400, hide: 200 }}
                                  overlay={
                                    <Tooltip id={`status-tooltip-${item._id}`}>
                                      <StatusHoverContent
                                        item={item}
                                        hoverData={statusHoverData[item._id]}
                                      />
                                    </Tooltip>
                                  }
                                  onToggle={(show) => {
                                    if (show) fetchStatusHoverData(item);
                                  }}
                                >
                                  <div>
                                    <Select
                                      value={statusOptions.find(o => o.value === item?.status) || null}
                                      onChange={(opt) => handleStatusChange(opt, item)}
                                      options={statusOptions}
                                      placeholder="Open"
                                      isSearchable={false}
                                      styles={{
                                        control: (base, state) => ({
                                          ...base,
                                          minHeight: "30px",
                                          height: "30px",
                                          fontSize: "0.85rem",
                                          backgroundColor: state.hasValue
                                            ? state.selectProps.value.color
                                            : base.backgroundColor,
                                          borderColor: state.hasValue
                                            ? state.selectProps.value.color
                                            : base.borderColor,
                                          boxShadow: "none",
                                          "&:hover": {
                                            borderColor: state.hasValue
                                              ? state.selectProps.value.color
                                              : base.borderColor,
                                          },
                                        }),
                                        singleValue: (base) => ({
                                          ...base,
                                          color: "#fff",
                                          fontWeight: 600,
                                        }),
                                        valueContainer: (base) => ({
                                          ...base,
                                          padding: "0 8px",
                                        }),
                                        option: (base, state) => ({
                                          ...base,
                                          fontSize: "0.85rem",
                                          color: state.isSelected ? "#fff" : state.data.color,
                                          backgroundColor: state.isSelected
                                            ? state.data.color
                                            : state.isFocused
                                              ? `${state.data.color}22`
                                              : "#fff",
                                          position: "relative",
                                          padding: "6px 12px",
                                          "&:not(:last-child)::after": {
                                            content: '""',
                                            position: "absolute",
                                            left: "8px",
                                            right: "8px",
                                            bottom: 0,
                                            height: "1px",
                                            backgroundColor: "#2536f5",
                                            opacity: 0.7,
                                          },
                                        }),
                                        indicatorsContainer: (base) => ({
                                          ...base,
                                          height: "30px",
                                        }),
                                        dropdownIndicator: (base) => ({
                                          ...base,
                                          color: "#fff",
                                          padding: "4px",
                                          "&:hover": { color: "#fff" },
                                        }),
                                        indicatorSeparator: () => ({
                                          display: "none",
                                        }),
                                      }}
                                    />
                                  </div>
                                </OverlayTrigger>
                              </td>

                              <td className="text-center align-middle" style={{ width: "24%", whiteSpace: "nowrap" }}>
                                {item?.documents?.length > 0 &&
                                  item?.documents[0]?.startsWith("http") ? (
                                  <button
                                    onClick={async () => {
                                      const prefix = "https://rdclive.nyc3.digitaloceanspaces.com/my%20spaces/";
                                      try {
                                        const documentNames = item.documents.map((doc) => doc.replace(prefix, ""));
                                        const documentNewNames = item.documents.map((doc, i) => `Ticket_Document_${i + 1}`);
                                        const response = await axios.post("s3-services/download-images", { paths: documentNames, filenames: documentNewNames });
                                        const signedUrls = response.data.signedUrls;
                                        for (let i = 0; i < signedUrls.length; i++) {
                                          const { signedUrl, error } = signedUrls[i];
                                          if (error) { console.error(error); continue; }
                                          const link = document.createElement("a");
                                          link.href = signedUrl;
                                          document.body.appendChild(link);
                                          link.click();
                                          document.body.removeChild(link);
                                          await new Promise((resolve) => setTimeout(resolve, 5000));
                                        }
                                      } catch (error) {
                                        console.error("Error fetching signed URLs:", error);
                                      }
                                    }}
                                    type="button"
                                    className="btn btn-soft-light btn-sm p-1"
                                    title="Download"
                                  >
                                    <i className="bx bx-download fs-6"></i>
                                  </button>
                                ) : item?.documents?.length > 0 ? (
                                  <button
                                    onClick={async () => {
                                      const response = await axios.post(PDF_DOWNLOAD_URL, {
                                        id: item?._id,
                                      });
                                      response?.data?.documents?.forEach((doc) => {
                                        const url = `${SERVER_URL}${doc}`;
                                        const extension = doc.substring(doc.lastIndexOf(".") + 1);
                                        fetch(url)
                                          .then((r) => r.arrayBuffer())
                                          .then((buffer) => {
                                            const blobUrl = window.URL.createObjectURL(new Blob([buffer]));
                                            const link = document.createElement("a");
                                            link.href = blobUrl;
                                            link.download = `ticket.${extension}`;
                                            link.click();
                                          });
                                      });
                                    }}
                                    type="button"
                                    className="btn btn-soft-light btn-sm p-1"
                                    title="Download"
                                  >
                                    <i className="bx bx-download fs-6"></i>
                                  </button>
                                ) : (
                                  <span className="text-muted small">NA</span>
                                )}
                              </td>
                              <td>
                                <OverlayTrigger
                                  placement="bottom"
                                  delay={{ show: 100, hide: 200 }}
                                  overlay={
                                    <Tooltip id={`tooltip-${item._id}`}>
                                      <div style={{ textAlign: 'left' }}>
                                        <p className="mb-1">
                                          Phone:{item.phone || "N/A"}
                                        </p>
                                        <p className="mb-0">
                                          Details: {item.details || "No details"}
                                        </p>
                                      </div>
                                    </Tooltip>
                                  }
                                >
                                  <span className="d-inline-block">
                                    <button
                                      className="btn btn-outline-primary btn-sm"
                                      onClick={() => {
                                        setSelectedTicket(item);
                                        fetchConsumedItemsDetails(item);
                                        tog_details();
                                      }}
                                    >
                                      View
                                    </button>
                                  </span>
                                </OverlayTrigger>
                              </td>
                              <td>
                                {decode.id == item.assignedTo?._id &&
                                  item.status !== "Completed" &&
                                  item.assignSpecificVendors.length == 0 ? (
                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => {
                                      tog_open_view();
                                      getVendor(item.companyID, item._id);
                                      setSelectedTicket(item);
                                    }}
                                  >
                                    Assign
                                  </button>
                                ) : !item.isMovedToVendorPortal ? (
                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => {
                                      tog_open_view();
                                      getVendor(item.companyID, item._id);
                                      setSelectedTicket(item);
                                    }}
                                  >
                                    Assign
                                  </button>
                                ) : (
                                  <button className="btn btn-success btn-sm">
                                    Assigned
                                  </button>
                                )}
                              </td>
                              <td>
                                <button
                                  className="btn btn-outline-info btn-sm"
                                  onClick={(e) => {
                                    setShowLogs((prev) => ({
                                      ...prev,
                                      data: item?.history,
                                      value: true,
                                    }));
                                  }}
                                >
                                  View Log
                                </button>
                              </td>
                              <td className="text-capitalize">
                                <div style={{ position: "relative" }}>
                                  {notesCount[item._id] ? (
                                    <Badge
                                      style={{
                                        background: "#fd625e",
                                        position: "absolute",
                                        right: 0,
                                        top: "-7px",
                                      }}
                                    >
                                      {notesCount[item._id]}
                                    </Badge>
                                  ) : (
                                    ""
                                  )}
                                  <button
                                    className="btn btn-outline-info btn-sm"
                                    onClick={() => {
                                      getNotes(item._id);
                                      setShowModal(true);
                                    }}
                                  >
                                    View Memo
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>

                    {/* ── Modals (unchanged) ── */}
                    <Modal size="lg" isOpen={modal_details} toggle={tog_details}>
                      <div className="modal-header">
                        <h5 className="modal-title mt-0" id="myLargeModalLabel">
                          View Ticket Details
                        </h5>
                        <button
                          onClick={tog_details}
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <Form>
                          <>
                            <div className="row align-items-center">
                              <div className="col-md-4">
                                <div className="mb-3">
                                  <Label className="form-label" htmlFor="formrow-facility-input">Company Name</Label>
                                  <Input type="text" value={selectedTicket.companyDomain} className="form-control" id="formrow-room-input" readOnly />
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="mb-3">
                                  <Label className="form-label" htmlFor="formrow-facility-input">Status</Label>
                                  <Input type="text" value={selectedTicket.status} className="form-control" id="formrow-room-input" readOnly />
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="mb-3">
                                  <Label className="form-Label">Property Name</Label>
                                  <Input type="text" value={selectedTicket.property} className="form-control" id="formrow-room-input" readOnly />
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="mb-3">
                                  <Label className="form-Label">Suite</Label>
                                  <Input type="text" value={selectedTicket.suite} className="form-control" id="formrow-room-input" readOnly />
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="mb-3">
                                  <Label className="form-label" htmlFor="formrow-room-input">requestType</Label>
                                  <Input type="text" value={requestTypeLabel(selectedTicket)} className="form-control" id="formrow-room-input" readOnly />
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="mb-3">
                                  <Label className="form-label" htmlFor="formrow-phone-input">Phone</Label>
                                  <Input type="text" value={selectedTicket.phone} className="form-control" id="formrow-room-input" readOnly />
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="mb-3">
                                  <Label className="form-label" htmlFor="formrow-email-input">Email</Label>
                                  <Input type="text" value={selectedTicket.email} className="form-control" id="formrow-room-input" readOnly />
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="mb-3">
                                  <Label className="form-label" htmlFor="formrow-email-input">Name</Label>
                                  <Input type="text" value={selectedTicket.name} className="form-control" id="formrow-room-input" readOnly />
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="mb-3">
                                  <Label className="form-label" htmlFor="formrow-phone-input">Permission to enter</Label>
                                  <Input type="text" value={selectedTicket.permission} className="form-control" id="formrow-room-input" readOnly />
                                </div>
                              </div>
                              {selectedTicket.building && (
                                <div className="col-md-4">
                                  <div className="mb-3">
                                    <Label className="form-label" htmlFor="formrow-phone-input">Building Name</Label>
                                    <Input type="text" value={selectedTicket.building} className="form-control" id="formrow-room-input" readOnly />
                                  </div>
                                </div>
                              )}
                              <div className="col-md-4">
                                <div className="mb-3">
                                  <Label className="form-label" htmlFor="formrow-phone-input">Rating</Label>
                                  <div>
                                    <td>
                                      <Rating initialValue={selectedTicket.ratings} readonly={true} size={20} />
                                    </td>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-12">
                                <div className="mb-3">
                                  <label htmlFor="basicpill-address-input" className="form-label">Details</label>
                                  <textarea id="basicpill-address-input" className="form-control" rows="3" readOnly placeholder={selectedTicket.details}></textarea>
                                </div>
                              </div>
                              <div className="col-md-12">
                                <div className="mb-3">
                                  <label htmlFor="basicpill-address-input" className="form-label">Customer Feedback</label>
                                  <textarea id="basicpill-address-input" className="form-control" rows="3" readOnly placeholder={selectedTicket?.reviews}></textarea>
                                </div>
                              </div>
                              <ImagesDisplay documents={selectedTicket.documents || []} />
                            </div>
                            <Col md={12}>
                              {inventoryItemConsumedDetails ? (
                                <div className="mb-4">
                                  <Row className="g-4">
                                    {inventoryItemConsumedDetails.consumed_items.map((item, index) =>
                                      item.consumed.map((consumption, consIndex) => (
                                        <Col md={12} key={`${index}-${consIndex}`}>
                                          <Card className="h-100 shadow-lg border-0 rounded-3 transition-all hover-shadow">
                                            <CardBody className="p-4">
                                              <CardTitle tag="h6" className="fw-bold text-dark mb-3">
                                                {item.name}
                                              </CardTitle>
                                              <div className="d-flex flex-column gap-2">
                                                <div className="d-flex justify-content-between">
                                                  <span className="fw-semibold text-muted">SKU</span>
                                                  <span>{item.sku.join(', ')}</span>
                                                </div>
                                                <div className="d-flex justify-content-between">
                                                  <span className="fw-semibold text-muted">Current Quantity</span>
                                                  <span>{item.current_quantity}</span>
                                                </div>
                                                <div className="d-flex justify-content-between">
                                                  <span className="fw-semibold text-muted">Consumed Quantity</span>
                                                  <span>{consumption.consumed_quantity}</span>
                                                </div>
                                                <div className="d-flex justify-content-between">
                                                  <span className="fw-semibold text-muted">Used Role (Id)</span>
                                                  <span>{`${consumption.used_by.role} (ID: ${consumption.used_by.id})`}</span>
                                                </div>
                                                <div className="d-flex justify-content-between">
                                                  <span className="fw-semibold text-muted">Used Name</span>
                                                  <span>{`${consumption.used_by.name}`}</span>
                                                </div>
                                                <div className="d-flex justify-content-between">
                                                  <span className="fw-semibold text-muted">Comment</span>
                                                  <span className="text-truncate" style={{ maxWidth: '150px' }}>
                                                    {consumption.comment}
                                                  </span>
                                                </div>
                                              </div>
                                            </CardBody>
                                          </Card>
                                        </Col>
                                      ))
                                    )}
                                  </Row>
                                </div>
                              ) : (
                                <p className="text-muted fst-italic">No consumed items data available.</p>
                              )}
                            </Col>
                          </>
                        </Form>
                        <div className="d-flex justify-content-end mt-3">
                          <button className="btn btn-primary" onClick={() => handlePrint(selectedTicket)}>
                            Print
                          </button>
                        </div>
                      </div>
                    </Modal>

                    <Modal size="lg" isOpen={model_open} toggle={tog_open_view}>
                      <div className="modal-header">
                        <h5 className="modal-title mt-0" id="myLargeModalLabel">Assign</h5>
                        <button onClick={tog_open_view} type="button" className="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "15px", padding: "5px" }}>
                          <div style={{ marginRight: "15px" }} class="form-check">
                            <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" checked={moveTo == "all vendors"} onClick={() => { setchecked(true); setMoveTo("all vendors"); }} />
                            <label class="form-check-label" for="flexRadioDefault1">Assign to All Vendors</label>
                          </div>
                          <div style={{ marginRight: "10px" }} class="form-check">
                            <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" checked={moveTo == "specific vendors"} onClick={() => { setchecked(false); setMoveTo("specific vendors"); }} />
                            <label class="form-check-label" for="flexRadioDefault2">Assign to Specified Vendors</label>
                          </div>
                          <div style={{ marginRight: "10px" }} class="form-check">
                            <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault3" checked={moveTo == "specific technical staff"} onClick={() => { setMoveTo("specific technical staff"); }} />
                            <label class="form-check-label" for="flexRadioDefault3">Assign to Maintenance Team</label>
                          </div>
                        </div>
                        {moveTo == "specific vendors" && (
                          <>
                            <Card>
                              <CardBody>
                                <div className="filter-sec">
                                  <Form>
                                    <div class="row align-items-center">
                                      <div className="col-md-4">
                                        <div className="mb-3">
                                          <Label className="form-Label">Names</Label>
                                          <Select isMulti onChange={(selectedOption) => { const names = []; selectedOption.map((property) => { names.push(property.value); }); setSelectedName(names); }} value={selectedName.map((item) => { return { label: item, value: item }; })} options={vendor.map((item) => { return { label: item.first_name, value: item.first_name }; })} className="basic-multi-select" classNamePrefix="select" />
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="mb-3">
                                          <Label className="form-Label">Category</Label>
                                          <Select isMulti value={selectedCategories.map((item) => { return { label: item, value: item }; })} onChange={(selectedOption) => { const category = []; selectedOption.map((property) => { category.push(property.value); }); setSelectedCategories(category); }} options={specialties.map((item) => { return { label: item, value: item }; })} className="basic-multi-select" classNamePrefix="select" />
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="mb-3">
                                          <Label className="form-Label">Contact No</Label>
                                          <Select isMulti value={selectedContact.map((item) => { return { label: item, value: item }; })} onChange={(selectedOption) => { const contact_no = []; selectedOption.map((property) => { contact_no.push(property.value); }); setSelectedContact(contact_no); }} options={vendor.map((item) => { return { label: item.contact_no, value: item.contact_no }; })} className="basic-multi-select" classNamePrefix="select" />
                                        </div>
                                      </div>
                                      <div className="col-md-2 text-end">
                                        <button type="submit" className="btn btn-primary" onClick={(e) => { e.preventDefault(); specificVendorSearch(); }}>Search</button>
                                      </div>
                                      <div className="col-md-1">
                                        <button type="submit" className="btn btn-light" onClick={(e) => { e.preventDefault(); clear(); }}>Clear</button>
                                      </div>
                                    </div>
                                  </Form>
                                </div>
                              </CardBody>
                            </Card>
                            <div style={{ marginTop: "15px", display: "flex", alignItems: "center" }} className="table-responsive">
                              <Table className="table-striped table-bordered mb-0">
                                <thead>
                                  <tr>
                                    <th></th>
                                    <th scope="col">#1</th>
                                    <th scope="col">Category</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Address</th>
                                    <th scope="col">Agency Name</th>
                                    <th scope="col">Contact</th>
                                  </tr>
                                </thead>
                                {vendor.map((item, i) => {
                                  return (
                                    <tbody key={i}>
                                      <tr>
                                        <div style={{ marginLeft: "15px" }} class="form-check">
                                          <input class="form-check-input" type="radio" name="flexTableRadioDefault" onClick={() => { setTableCheck(true); setTableContent(item._id); }} />
                                        </div>
                                        <td>{i + 1}</td>
                                        <td>{item.specialties.length > 0 ? item.specialties.map((a) => a.specialty).join() : "No Category found"}</td>
                                        <td>{item.first_name}</td>
                                        <td>{item.address}</td>
                                        <td>{item.agency_name}</td>
                                        <td>{item.contact_no}</td>
                                      </tr>
                                    </tbody>
                                  );
                                })}
                              </Table>
                            </div>
                          </>
                        )}
                        {moveTo == "specific technical staff" && (
                          <Card>
                            <CardBody>
                              <div className="filter-sec">
                                <Form>
                                  <div class="row align-items-center">
                                    <div className="col-md-4">
                                      <div className="mb-3">
                                        <Label className="form-Label">Name</Label>
                                        <Select isMulti onChange={(selectedOption) => { const names = []; selectedOption.map((property) => { names.push(property.value); }); setSelectedName(names); }} value={selectedName.map((item) => { return { label: item, value: item }; })} options={originalStaff.map((item) => { return { label: item.first_name, value: item.first_name }; })} className="basic-multi-select" classNamePrefix="select" />
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="mb-3">
                                        <Label className="form-Label">Email</Label>
                                        <Select isMulti value={selectedEmail.map((item) => { return { label: item, value: item }; })} onChange={(selectedOption) => { const emails = []; selectedOption.map((property) => { emails.push(property.value); }); setSelectedEmail(emails); }} options={originalStaff.map((item) => { return { label: item.email, value: item.email }; })} className="basic-multi-select" classNamePrefix="select" />
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="mb-3">
                                        <Label className="form-Label">Contact No</Label>
                                        <Select isMulti value={selectedContact.map((item) => { return { label: item, value: item }; })} onChange={(selectedOption) => { const contact_no = []; selectedOption.map((property) => { contact_no.push(property.value); }); setSelectedContact(contact_no); }} options={originalStaff.map((item) => { return { label: item.contact_no, value: item.contact_no }; })} className="basic-multi-select" classNamePrefix="select" />
                                      </div>
                                    </div>
                                    <div className="col-md-2 text-end">
                                      <button type="submit" className="btn btn-primary" onClick={(e) => { e.preventDefault(); technicalStaffSearch(); }}>Search</button>
                                    </div>
                                    <div className="col-md-1">
                                      <button type="submit" className="btn btn-light" onClick={(e) => { e.preventDefault(); clear(); }}>Clear</button>
                                    </div>
                                  </div>
                                </Form>
                              </div>
                            </CardBody>
                          </Card>
                        )}
                        {moveTo == "specific technical staff" && (
                          <div style={{ marginTop: "15px", display: "flex", alignItems: "center" }} className="table-responsive">
                            <Table className="table-striped table-bordered mb-0">
                              <thead>
                                <tr>
                                  <th></th>
                                  <th scope="col">#</th>
                                  <th scope="col">Category</th>
                                  <th scope="col">Name</th>
                                  <th scope="col">Address</th>
                                  <th scope="col">Contact</th>
                                  <th scope="col">Rating</th>
                                </tr>
                              </thead>
                              {technicalStaff.map((item, i) => {
                                return (
                                  <tbody key={i}>
                                    <tr>
                                      <div style={{ marginLeft: "15px" }} class="form-check">
                                        <input class="form-check-input" type="radio" name="flexTableRadioDefault" onClick={() => { setTableCheck(true); setTableContent(item._id); }} />
                                      </div>
                                      <td>{i + 1}</td>
                                      <td>{item.specialties.length > 0 ? item.specialties.map((a) => a.speciality).join() : "No Category found"}</td>
                                      <td>{item.first_name}</td>
                                      <td>{item.email}</td>
                                      <td>{item.contact_no}</td>
                                      <td><Rating ratingValue={item.rating * 20} readonly={true} size={20} /></td>
                                    </tr>
                                  </tbody>
                                );
                              })}
                            </Table>
                          </div>
                        )}
                      </div>
                      {moveTo == "specific vendors" || moveTo == "specific technical staff" ? (
                        <div style={{ display: "flex", justifyContent: "center", marginTop: "15px", padding: "5px" }}>
                          <button onClick={() => { moveToSpecificVendor(selectedTicket._id, tableContent); setModel_open(!model_open); }} style={{ marginRight: "10px" }} className="btn btn-primary">
                            {loading && <div id="saveSpinner" style={{ height: "15px", width: "15px", marginLeft: "5px" }} class="spinner-border" role="status"></div>}
                            Submit
                          </button>
                          <button className="btn btn-light" onClick={(e) => { tog_open_view(); }}>Cancel</button>
                        </div>
                      ) : (
                        <div style={{ display: "flex", justifyContent: "center", marginTop: "15px", padding: "5px" }}>
                          {moveTo == "all vendors" && (
                            <button style={{ marginRight: "10px" }} onClick={() => { moveToAllVendor(selectedTicket._id); setModel_open(!model_open); }} className="btn btn-primary">
                              {loading && <div id="saveSpinner" style={{ height: "15px", width: "15px", marginLeft: "5px" }} class="spinner-border" role="status"></div>}
                              Submit
                            </button>
                          )}
                          <button className="btn btn-light" onClick={(e) => { tog_open_view(); }}>Cancel</button>
                        </div>
                      )}
                    </Modal>

                    <Modal size="lg" isOpen={showlogs?.value} toggle={() => { setShowLogs((prev) => ({ ...prev, data: [], value: false })); }}>
                      <div className="modal-header">
                        <h5 className="modal-title mt-0" id="myLargeModalLabel">History Log</h5>
                        <button onClick={() => { setShowLogs((prev) => ({ ...prev, data: [], value: false })); }} type="button" className="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <div className=" d-flex flex-column ml-2">
                          {showlogs?.data?.map((log, i) => (
                            <div key={log?._id} className="d-flex mb-1">
                              <div className="d-flex flex-column pr-4 align-items-center">
                                <div className="rounded-circle py-2 px-3 bg-primary text-white mb-1">{i + 1}</div>
                                <div className={`${i + 1 !== showlogs?.data?.length ? "line h-100" : ""}`}></div>
                              </div>
                              <div>
                                <p className="lead pb-3">
                                  <span className="text-black mx-2"><strong>{log?.userName} ({log.actionBy})</strong></span>
                                  {log?.action}.{" "}
                                  <small className="text-muted mx-2">{moment(log?.createdAt).calendar()}</small>
                                </p>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </Modal>

                    <Modal isOpen={showModal} toggle={() => setShowModal(false)} size="lg">
                      <div className="modal-header">
                        <h5 className="modal-title">Ticket Notes / Memo</h5>
                        <button type="button" className="close" onClick={() => setShowModal(false)}>
                          <span>&times;</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        {showNotes.length > 0 ? (
                          <ul className="list-group list-group-flush">
                            {showNotes.map((note) => {
                              return (
                                <li key={note._id} className="list-group-item px-0">
                                  <div className="d-flex justify-content-between align-items-start">
                                    <div>
                                      <div className="fw-semibold">
                                        {note.userName || "User"}
                                        {note.user && (
                                          <span className="badge bg-secondary ms-2 text-capitalize">
                                            {note.user}
                                          </span>
                                        )}
                                      </div>
                                      <p className="mb-1 mt-1 text-dark">{note.note}</p>
                                    </div>
                                    <small className="text-muted text-nowrap ms-3">
                                      {moment(note.createdAt).format("DD MMM YY")}
                                      <br />
                                      {moment(note.createdAt).format("hh:mm A")}
                                    </small>
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                        ) : (
                          <div className="text-center text-muted py-3">No notes available yet.</div>
                        )}
                        <div className="mt-4">
                          <Input
                            type="textarea"
                            rows="3"
                            placeholder="Add a new note..."
                            value={notesInput}
                            onChange={(e) => setNotesInput(e.target.value)}
                          />
                          <Button color="primary" className="mt-2" onClick={() => sendNotes(ticketID)} disabled={!notesInput.trim()}>
                            Add Note
                          </Button>
                        </div>
                      </div>
                    </Modal>

                    <MaintenanceFlowDetailsForm
                      item={selectedTicket}
                      isOpen={modal_workflow}
                      onClose={tog_workflow}
                      getTechnicalStaffTickets={getTechnicalStaffTickets}
                      getTotalTickets={getTotalTickets}
                      targetStatus={ticketStatus}
                    />
                  </div>

                  <Row className="proress-style mt-3">
                    <Col xl={3}></Col>
                    <Col xl={9}>
                      <div className="pagination-bar">
                        <Pagination aria-label="Page navigation example">
                          <PaginationItem disabled={pageNumber === 1}>
                            <PaginationLink
                              previous
                              onClick={(e) => {
                                e.preventDefault();
                                if (pageNumber > 1) {
                                  getTechnicalStaffTickets(pageNumber - 1, "previous");
                                }
                              }}
                            >
                              Previous
                            </PaginationLink>
                          </PaginationItem>
                          {renderPageNumbers()}
                          <PaginationItem disabled={Math.ceil(totalTickets / 10) === pageNumber || Math.ceil(totalTickets / 10) === 0}>
                            <PaginationLink
                              next
                              onClick={(e) => {
                                e.preventDefault();
                                const totalPages = Math.ceil(totalTickets / 10);
                                if (pageNumber < totalPages) {
                                  getTechnicalStaffTickets(pageNumber + 1, "next");
                                }
                              }}
                            >
                              Next
                            </PaginationLink>
                          </PaginationItem>
                        </Pagination>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment >
  );
};

export default TechnicalStaffTickets;

// ─────────────────────────────────────────────────────────────
// ImagesDisplay — unchanged
// ─────────────────────────────────────────────────────────────
const ImagesDisplay = ({ documents }) => {
  const [signedUrls, setSignedUrls] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchSignedUrls = async () => {
      const prefix = "https://rdclive.nyc3.digitaloceanspaces.com/my%20spaces/";
      try {
        const documentNames = documents.map((doc) => doc.replace(prefix, ""));
        const documentNewNames = documents.map((doc, i) => `Ticket_Image_${i + 1}`);
        setLoading(true);
        const response = await axios.post("s3-services/download-images", {
          paths: documentNames,
          filenames: documentNewNames,
        });
        const signedUrls = response.data.signedUrls;
        const validUrls = signedUrls.filter(({ error }) => !error).map(({ signedUrl }) => signedUrl);
        setSignedUrls(validUrls);
      } catch (error) {
        console.error("Error fetching signed URLs:", error);
      } finally {
        setLoading(false);
      }
    };
    if (documents.length > 0) {
      fetchSignedUrls();
    }
  }, [documents]);

  return (
    <>
      {loading ? (
        <div>Loading...</div>
      ) : (
        documents.length > 0 && (
          <div className="col-md-12">
            <div className="mb-3">
              <label htmlFor="basicpill-address-input" className="form-label">Images</label>
              <div className="container">
                <div className="row">
                  {signedUrls.map((url, index) => (
                    <div className="col-12 col-md-4 mb-4" key={index}>
                      <div className="card">
                        <img src={url} className="card-img-top" alt={`Image ${index + 1}`} style={{ minHeight: 200, maxHeight: 200 }} />
                        <div className="card-body">
                          <div className="d-flex justify-content-between align-items-center">
                            <p className="card-text">Image {index + 1}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )
      )}
    </>
  );
};